import { Container, Skeleton } from "@mui/material";
import ErrorFullScreenMessage from "../../../components/fullScreenMessage/ErrorFullScreenMessage";
import { BANNER } from "../../../enums/QueryKeys";
import { fetchBanner } from "../../../enums/queryFunction/Fetch";
import { useQuery } from "@tanstack/react-query";
import { loadingStyle } from "../enums/BannerStyles";
import useUser from "../../../hooks/useUser";

export default function useBanner() {
  const { currentClinic } = useUser();
  const { data, isLoading, error } = useQuery({
    queryKey: [BANNER],
    queryFn: () => fetchBanner(currentClinic?.id),
    staleTime: Infinity,
  });

  if (isLoading) {
    return (
      <Container sx={loadingStyle}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{ borderRadius: "10px", transform: "scale(1.2)" }}
        />
      </Container>
    );
  } else if (error) {
    return <ErrorFullScreenMessage />;
  }

  if (data != undefined && data != null && data != "") {
    return data;
  }

  return null;
}
